// Small always-on corner HUD: `<cameraFps>/<processedFps> fps`. Renders
// `-` for either half when its rolling window is empty (camera idle, or
// processed side hasn't ticked yet because the worker is cold-starting).

interface FpsHudProps {
  cameraFps: number | null;
  processedFps: number | null;
}

function fmt(v: number | null): string {
  return v === null ? '-' : Math.round(v).toString();
}

export function FpsHud({ cameraFps, processedFps }: FpsHudProps) {
  const camera = fmt(cameraFps);
  const processed = fmt(processedFps);
  return (
    <div
      className="pointer-events-none absolute left-3 top-3 rounded bg-black/70 px-2 py-1 font-mono text-xs tabular-nums text-white ring-1 ring-white/10"
      aria-hidden="true"
      data-testid="fps-hud"
    >
      {camera}/{processed} fps
    </div>
  );
}
